import {
  GetSiniestrosEmpresaApi,
  GetSiniestrosDetallesApi,
  PostTagManager,
} from '../../../../../services/SiniestrosEmpresa';
import { openCloseToast } from '../../../../Global/actions';
import validaciones from '../../../../../helpers/validaciones';
import { filterType } from '../../../../../helpers/filterHelper';

export const loading = (isLoading) => ({
  type: 'LOADING_SINIESTRO_EMPRESA',
  isLoading,
});

export const resetStateSiniestroEmpresa = () => ({
  type: 'RESET_STATE_SINIESTRO_EMPRESA',
});

export const setSiniestro = (siniestro) => ({
  type: 'SET_SINIESTRO',
  siniestro,
});

export const resetDetalleSiniestroEmpresa = () => ({
  type: 'RESET_DETALLE_SINIESTRO_EMPRESA',
});

export const setSiniestrosEmpresa = (siniestros, total) => ({
  type: 'SET_SINIESTROS_EMPRESA',
  siniestros,
  total,
});
export const setSiniestrosEmpresaFiltros = (siniestrosWithFilter) => ({
  type: 'SET_SINIESTROS_EMPRESA_CON_FILTROS',
  siniestrosWithFilter,
});

export const setSiniestroFilters = (filtros) => ({
  type: 'SET_SINIESTRO_FILTERS',
  filtros,
});

export const setSiniestroEmpresaDetails = (details) => ({
  type: 'SET_SINIESTRO_EMPRESA_DETAILS',
  details,
});
export const setDocumentSiniestro = (listDocuments) => ({
  type: 'SET_DOCUMENT_SINIESTRO',
  listDocuments,
});
export const setshowNoDataEmpresa = (details) => ({
  type: 'SET_SHOW_DATA_EMPRESA',
  details,
});

export const setIsDownloadExcel = (isDownloadLoading) => ({
  type: 'LOADING_SINIESTRO_DOWNLOAD_EXCEL',
  isDownloadLoading,
});

export const successTagManager = (success) => ({
  type: 'SUCCESS_TAG_MANAGER',
  success,
});

export const doGetSiniestroFilters = (ListadoSiniestros) => async (dispatch) => {
  try {
    const filters = [
      {
        column: 'ReposoActivo',
        name: 'Reposo',
        showName: false,
        values: [
          { text: 'Activo', value: true },
          { text: 'No Activo', value: false },
        ],
      },
      {
        column: 'FechaPresentacion',
        filterValue: 'IdFechaPresentacion',
        name: 'Fecha presentación',
        showName: false,
        type: filterType.date,
        max: new Date(),
        oneYearInterval: true,
      },
      {
        column: 'FechaSiniestro',
        filterValue: 'IdFechaSiniestro',
        name: 'Fecha siniestro',
        type: filterType.date,
        showName: false,
        max: new Date(),
        oneYearInterval: true,
      },
      {
        column: 'PrestacionEconomica',
        name: 'Prestaciones económicas',
        showName: false,
        values: [
          { text: 'Si', value: true },
          { text: 'No', value: false },
        ],
      },
    ];

    let values = ListadoSiniestros.map((item) => ({
      text: item.TipoSiniestro.DescripcionTipoSiniestro,
      value: item.TipoSiniestro.IdTipoSiniestro,
    }));

    values = validaciones.getUnique(values, 'text');
    filters.push({
      column: 'TipoSiniestro',
      name: 'Siniestro',
      showName: false,
      type: 'object',
      values,
    });

    dispatch(setSiniestroFilters(filters));
  } catch (e) {
    console.error(e);
  }
};

export const doGetSiniestrosEmpresa = (filtros) => async (dispatch) => {
  dispatch(loading(true));
  try {
    filtros.RutEmpresa = localStorage.getItem('rutEnterprise') ?? filtros.RutEmpresa;
    const request = await GetSiniestrosEmpresaApi(filtros);
    if (request.status === 200) {
      const result = await request.json();
      if (result.ListadoSiniestros !== null) {
        dispatch(setSiniestrosEmpresa(result.ListadoSiniestros, result.TotalSiniestros));
        dispatch(doGetSiniestroFilters(result.ListadoSiniestros));
        dispatch(setSiniestrosEmpresaFiltros(result.ListadoSiniestros));
      }
    }
  } catch (e) {
    dispatch(
      openCloseToast({
        isToastOpen: true,
        msgToast: 'Error al obtener la lista de siniestros',
        typeStyle: 'error',
        displayTime: 5000,
      }),
    );
  }
  dispatch(loading(false));
};

export const doGetSiniestroEmpresaDetailsApi = (data) => async (dispatch) => {
  dispatch(loading(true));
  try {
    const request = await GetSiniestrosDetallesApi(data.IdSiniestro);
    if (request.status === 200) {
      const result = await request.json();
      const prestacionesEconomicas = result.Siniestro.ListadoPrestacionesEconomicas.map((item) => {
        const prestacion = Object.assign({}, item, {
          IdSiniestro: data.IdSiniestro,
          FechaSiniestro: data.FechaSiniestro,
          TipoSiniestro: data.TipoSiniestro.DescripcionTipoSiniestro,
        });

        return prestacion;
      });

      result.Siniestro.ListadoReposo.forEach((item) => {
        item.IsActive = item.FechaFin === null && item.TipoAlta === null;
      });

      const denuncias = result.Siniestro.Denuncias.map((item) => {
        const denuncia = Object.assign({}, item, {
          IdSiniestro: data.IdSiniestro,
        });

        return denuncia;
      });
      dispatch(
        setSiniestroEmpresaDetails({
          atencionesMedicas: result.Siniestro.ListadoAtencionesMedicas,
          periodosReposo: result.Siniestro.ListadoReposo,
          evaluacionesIncapa: result.Siniestro.ListadoEvaluacionIncapacidad,
          prestacionesEconomicas,
          denuncias,
        }),
      );
      dispatch(
        setshowNoDataEmpresa({
          showNoDataAtencionesMedicasEmpresa: !(
            result.Siniestro.ListadoAtencionesMedicas.length > 0
          ),
          showNoDataPeriodosReposoEmpresa: !(result.Siniestro.ListadoReposo.length > 0),
          showNoDataEvaluacionesIncapaEmpresa: !(
            result.Siniestro.ListadoEvaluacionIncapacidad.length > 0
          ),
          showNoDataPrestacionesEconomicasEmpresa: !(
            result.Siniestro.ListadoPrestacionesEconomicas.length > 0
          ),
        }),
      );
    }
  } catch (e) {
    console.log(e);
  }
  dispatch(loading(false));
};

export const doPostTagManagerApi = ({category, id, action, label, response}) => async (dispatch) => {
  const bodyFinal = {
    PartitionKey: category.toLowerCase(),
    RowKey: `${id}-${generarNumeroAleatorio(1,1000000000)}`,
    action,
    label,
    category,
    id,
    timeStamp: obtenerFechaActual(),
    response,
  }
  try {
    await PostTagManager(bodyFinal);
    dispatch(successTagManager(true));
  } catch (e) {
    dispatch(successTagManager(false));
  }
};

function generarNumeroAleatorio(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function obtenerFechaActual() {
  const fecha = new Date();
  
  const año = fecha.getFullYear();
  const mes = pad(fecha.getMonth() + 1); // Se agrega 1 porque los meses van de 0 a 11
  const dia = pad(fecha.getDate());
  const hora = pad(fecha.getHours());
  const minuto = pad(fecha.getMinutes());
  const segundo = pad(fecha.getSeconds());
  
  return `${año}/${mes}/${dia}/${hora}/${minuto}/${segundo}`;
}

function pad(n) {
  return n < 10 ? '0' + n : n; // Añade un cero delante si el número es menor que 10
}